import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { ManufacturerTableconstant } from "./ManufacturerConstant";

const initialState = {
  ManufacturerTableList: [],
  ManufacturerTable: {
    isLoading: true,
  },
  vehicleModelTypeId:[],
  VehicleManufactureEnableDisableList: [{}],
  ConnectorsEnableDisableList: [],

  AddManufacturer: [{}],

  AManufacturer: {
    isLoading: true,
  },
  AddVehicleModel: [{}],

  VehicleModel: {
    isLoading: false,
  },

  AddConnectorsModel: [{}],
  ConnectorsModels: {
    isLoading: false,
  },

  vehicleModelList: [],
  Model: {
    isLoading: false,
  },

  AddManufacturerTable: [{}],

  AManufacturerTable: {
    isLoading: false,
  },

  AddConnectorsTable: [],
  ConnectorsTable: {
    isLoading: false,
  },
  AddVehicleManufactureEnableDisableList: [{}],
  AddManufacturerTable: {
    isLoading: false,
  },

  //  11111
  ManufactureEnableDisableList: [{}],
  ManufacturerTable: {
    isLoading: false,
  },

  //update
  UpdateManufacturerList: [],
  UpdateManufacturer: {
    isLoading: true,
  },

  UpdateVehicalModelList: [],
  UpdateVehicalmode: {
    isLoading: true,
  },
  UpdateConnectorList: [],

  SelectVehicleListdata: [],
  SelectVehicleloading: {
    isLoading: true,
  },
  SelectVehicleModelListdata: [],
  SelectVehicleModelloading: {
    isLoading: false,
  },

  UpdateMapList: [],

  //get vehicle Variant
  vehicleVariantList: [],
  vehicleVariant: {
    isLoading: false,
  },
};

export const ManufacturerTableReducer = persistReducer(
  {
    storage,
    key: "ManufacturerTable",
    whitelist: [" ManufacturerTableList"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case ManufacturerTableconstant.MANUFACTURER_TABLE_REQUEST: {
        return {
          ...state,
          ManufacturerTableList: [],
          ManufacturerTable: {
            isLoading: true,
          },
        };
      }

      case ManufacturerTableconstant.MANUFACTURER_TABLE_RESPONSE: {
        return {
          ...state,
          ManufacturerTableList: payload,
          ManufacturerTable: {
            isLoading: false,
          },
        };
      }

      case ManufacturerTableconstant.GET_ADD_MANUFACTURER_REQUEST: {
        return {
          ...state,
          AddManufacturerTable: [],
          AManufacturerTable: {
            isLoading: true,
          },
        };
      }

      case ManufacturerTableconstant.GET_ADD_MANUFACTURER_RESPONSE: {
        return {
          ...state,
          AddManufacturerTable: payload,
          AManufacturerTable: {
            isLoading: false,
          },
        };
      }

      case ManufacturerTableconstant.GET_ADD_CONNECTORS_MODEL_REQUEST: {
        return {
          ...state,
          AddConnectorsTable: [],
          ConnectorsTable: {
            isLoading: true,
          },
        };
      }

      case ManufacturerTableconstant.GET_ADD_CONNECTORS_MODEL_RESPONSE: {
        return {
          ...state,
          AddConnectorsTable: payload,
          ConnectorsTable: {
            isLoading: false,
          },
        };
      }

      //post

      case ManufacturerTableconstant.POST_ADD_MANUFACTURER_REQUEST: {
        return {
          ...state,
          AddManufacturer: [],
          AManufacturer: {
            isLoading: true,
          },
        };
      }

      case ManufacturerTableconstant.POST_ADD_MANUFACTURER_RESPONSE: {
        return {
          ...state,
          AddManufacturer: payload,
          AManufacturer: {
            isLoading: false,
          },
        };
      }

      // ***********
      case ManufacturerTableconstant.POST_ADD_VEHICLE_MODEL_REQUEST: {
        return {
          ...state,
          AddVehicleModel: [],
          VehicleModel: {
            isLoading: true,
          },
        };
      }

      case ManufacturerTableconstant.MANUFACTURER_TABLE_RESPONSE: {
        return {
          ...state,
          AddVehicleModel: payload,
          VehicleModel: {
            isLoading: false,
          },
        };
      }

      case ManufacturerTableconstant.POST_ADD_CONNECTORS_MODEL_REQUEST: {
        return {
          ...state,
          AddConnectorsModel: [],
          ConnectorsModels: {
            isLoading: true,
          },
        };
      }

      case ManufacturerTableconstant.POST_ADD_CONNECTORS_MODEL_RESPONSE: {
        return {
          ...state,
          AddConnectorsModel: payload,
          ConnectorsModels: {
            isLoading: false,
          },
        };
      }
      //get vehicle model reducer

      case ManufacturerTableconstant.GET_ADD_VEHICLE_MODEL_REQUEST: {
        return {
          ...state,
          vehicleModelList: [],
          Model: {
            isLoading: true,
          },
        };
      }

      case ManufacturerTableconstant.GET_ADD_VEHICLE_MODEL_RESPONSE: {
        return {
          ...state,
          vehicleModelList: payload,
          Model: {
            isLoading: false,
          },
        };
      }

      //enable/dsable
      case ManufacturerTableconstant.VEHICLEMANUFACTURE_ENABLE_DISABLE_REQUEST: {
        return {
          ...state,
          VehicleManufactureEnableDisableList: [],
          ManufacturerTable: {
            isLoading: true,
          },
        };
      }
      case ManufacturerTableconstant.VEHICLEMANUFACTURE_ENABLE_DISABLE_RESPONSE: {
        return {
          ...state,
          VehicleManufactureEnableDisableList: payload,
          ManufacturerTable: {
            isLoading: false,
          },
        };
      }

      //enable/dsable

      case ManufacturerTableconstant.CONNECTORS_ENABLE_DISABLE_REQUEST: {
        return {
          ...state,
          ConnectorsEnableDisableList: [],
          ConnectorsTable: {
            isLoading: true,
          },
        };
      }
      case ManufacturerTableconstant.CONNECTORS_ENABLE_DISABLE_RESPONSE: {
        return {
          ...state,
          ConnectorsEnableDisableList: payload,
          ConnectorsTable: {
            isLoading: false,
          },
        };
      }

      //add vehicle manufacture reducer
      case ManufacturerTableconstant.ADD_VEHICLEMANUFACTURE_ENABLE_DISABLE_REQUEST: {
        return {
          ...state,
          AddVehicleManufactureEnableDisableList: [],
          AddManufacturerTable: {
            isLoading: true,
          },
        };
      }
      case ManufacturerTableconstant.ADD_VEHICLEMANUFACTURE_ENABLE_DISABLE_RESPONSE: {
        return {
          ...state,
          AddVehicleManufactureEnableDisableList: payload,
          AddManufacturerTable: {
            isLoading: false,
          },
        };
      }

      // update add manufacture

      case ManufacturerTableconstant.UPDATE_ADD_MANUFACTURER_REQUEST: {
        return {
          ...state,
          UpdateManufacturerList: [],
          UpdateManufacturer: {
            isLoading: true,
          },
        };
      }

      case ManufacturerTableconstant.UPDATE_ADD_MANUFACTURER_RESPONSE: {
        return {
          ...state,
          UpdateManufacturerList: payload,
          UpdateManufacturer: {
            isLoading: false,
          },
        };
      }
      //update connector

      case ManufacturerTableconstant.UPDATE_ADD_CONNECTOR_REQUEST: {
        return {
          ...state,
          UpdateConnectorList: [],
          UpdateConnector: {
            isLoading: true,
          },
        };
      }

      case ManufacturerTableconstant.UPDATE_ADD_CONNECTOR_RESPONSE: {
        return {
          ...state,
          UpdateConnectorList: payload,
          UpdateConnector: {
            isLoading: false,
          },
        };
      }

      //update vehicle model

      case ManufacturerTableconstant.UPDATE_ADD_VEHICLE_MODEL_REQUEST: {
        return {
          ...state,
          UpdateVehicalModelList: [],
          UpdateVehicalmode: {
            isLoading: true,
          },
        };
      }

      case ManufacturerTableconstant.UPDATE_ADD_VEHICLE_MODEL_RESPONSE: {
        return {
          ...state,
          UpdateVehicalModelList: payload,
          UpdateVehicalmode: {
            isLoading: false,
          },
        };
      }

      //get select vehicles

      case ManufacturerTableconstant.GET_SELECT_VEHICLE_REQUEST: {
        return {
          ...state,
          SelectVehicleListdata: [],
          SelectVehicleloading: {
            isLoading: true,
          },
        };
      }

      case ManufacturerTableconstant.GET_SELECT_VEHICLE_RESPONSE: {
        return {
          ...state,
          SelectVehicleListdata: payload,
          SelectVehicleloading: {
            isLoading: false,
          },
        };
      }

      //get select vehicles model

      case ManufacturerTableconstant.GET_SELECT_VEHICLE_MODEL_REQUEST: {
        return {
          ...state,
          SelectVehicleModelListdata: [],
          SelectVehicleModelloading: {
            isLoading: true,
          },
        };
      }

      case ManufacturerTableconstant.GET_SELECT_VEHICLE_MODEL_RESPONSE: {
        return {
          ...state,
          SelectVehicleModelListdata: payload,
          SelectVehicleModelloading: {
            isLoading: false,
          },
        };
      }

      //map

      case ManufacturerTableconstant.UPDATE_MAP_REQUEST: {
        return {
          ...state,
          UpdateMapList: [],
          UpdateMap: {
            isLoading: true,
          },
        };
      }

      case ManufacturerTableconstant.UPDATE_MAP_RESPONSE: {
        return {
          ...state,
          UpdateMapList: payload,
          UpdateMap: {
            isLoading: false,
          },
        };
      }

      // manufacturer enable desable

      case ManufacturerTableconstant.MANUFACTURER_ENABLE_DISABLE_REQUEST: {
        return {
          ...state,
          ManufactureEnableDisableList: [],
          ManufacturerTable: {
            isLoading: true,
          },
        };
      }
      case ManufacturerTableconstant.MANUFACTURER_ENABLE_DISABLE_RESPONSE: {
        return {
          ...state,
          ManufactureEnableDisableList: payload,
          ManufacturerTable: {
            isLoading: false,
          },
        };
      }

      //get vehicle variant
      case ManufacturerTableconstant.GET_ADD_VEHICLE_VARIANT_REQUEST: {
        return {
          ...state,
          vehicleVariantList: [],
          vehicleVariant: {
            isLoading: true,
          },
        };
      }

      case ManufacturerTableconstant.GET_ADD_VEHICLE_VARIANT_RESPONSE: {
        return {
          ...state,
          vehicleVariantList: payload,
          vehicleVariant: {
            isLoading: false,
          },
        };
      }
      
      case ManufacturerTableconstant.VEHICLE_MODEL_TYPE_REQUEST: {
        return {
          ...state,
          vehicleModelTypeId: [],
          
        };
      }

      case ManufacturerTableconstant.VEHICLE_MODEL_TYPE_RESPONSE: {
        return {
          ...state,
          vehicleModelTypeId: payload,
        };
      }

      default:
        return state;
    }
  }
);
